import { DecorativeBackground2 } from "../../DecorativeBackground2";
import { StatCard } from "./StatCard";

export const CustomerStatsSection = () => {

  const stats = [
    { value: "Ready to Spend.", label: "High-intent shoppers looking for their next purchase." },
    { value: "Ready to Return.", label: "Customers ready to follow your brand and return often." },
    { value: "Local Reach", label: "Connect directly with locals actively exploring your area." },
  ];

  return (
    <div>
      <div className="hidden lg:block">
      <section className="relative w-full flex justify-center py-12 px-[80px]">

      <DecorativeBackground2 />

      <div className="relative z-10 w-full max-w-[1700px] px-6 text-center">

        {/* top label */}
        <div className="flex justify-center items-center gap-2 text-white mb-6">
          <span className="w-2 h-2 bg-white rounded-full"></span>
          <span className="text-[18px]">Deals by Category</span>
        </div>

        {/* heading */}
        <h2 className="text-[56px] font-medium text-white mb-12 leading-tight">
          Your Customers Are
          <br />
          Waiting For You
        </h2>

         <p className="text-white text-[20px] mb-16 px-48">
              Thousands of locals use our app daily to decide where to spend. Publish your first offer today and bring them through your door.
            </p>

        {/* stat cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-center">

          {stats.map((stat, index) => (
            <StatCard
              key={index}
              value={stat.value}
              label={stat.label}
            />
          ))}

        </div>

      </div>
    </section>
      </div>

      <div className="block lg:hidden mt-12">
      <section className="relative w-full flex justify-center py-12 px-[20px]">

      <DecorativeBackground2 />

      <div className="relative z-10 w-full max-w-[1700px]  text-center">

        {/* top label */}
        <div className="flex justify-center items-center  gap-2 text-white mb-6">
          <span className="w-2 h-2 bg-white rounded-full"></span>
          <span className="text-[16px]">Deals by Category</span>
        </div>

        {/* heading */}
        <h2 className="text-[30px] text-white mb-4 leading-tight px-4">
          Your Customers Are
          Waiting For You
        </h2>

        <p className="text-white text-[12px] mb-8 px-12">
              Thousands of locals use our app daily to decide where to spend. Publish your first offer today and bring them through your door.
            </p>

        {/* stat cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 justify-center">

          {stats.map((stat, index) => (
            <StatCard
              key={index}
              value={stat.value}
              label={stat.label}
            />
          ))}

        </div>

      </div>
    </section>
      </div>
    </div>
    
  );
};